import { makeAutoObservable } from 'mobx';

import _ from 'lodash';
import { HttpClient } from 'services/http-client';
// import { LocationDto } from 'services/data-contracts';

export interface isValid {
  isValid: boolean;
}

class LocationStore {
  // locations?: LocationDto[];

  constructor() {
    makeAutoObservable(this);
  }


  // *createLocation(data: LocationDto) {
  //   const { response } = yield this.api.locationsCreate(data);
  //   this.locations = response.data.data;
  // }

  *getLocations() {

  }
}

export default LocationStore;
